import clsx from 'clsx'

import type { QuizQuestionAlternative } from '../../model/types'

type QuizChoicesProps = {
  alternatives: QuizQuestionAlternative[]
  value: string | null
  disabled?: boolean
  onChange: (alternativeUid: string) => void
}

export function QuizChoices({ alternatives, value, disabled, onChange }: QuizChoicesProps) {
  return (
    <div className="flex flex-col gap-2">
      {alternatives.map(alternative => (
        <button
          key={alternative.uid}
          type="button"
          disabled={disabled}
          onClick={() => onChange(alternative.uid)}
          className={clsx(
            'w-full rounded-xl border p-3 text-left text-sm font-medium transition-colors',
            value === alternative.uid
              ? 'border-[var(--color-brand)] bg-[var(--color-brand)]/10'
              : 'border-gray-200 bg-white'
          )}
        >
          {alternative.name}
        </button>
      ))}
    </div>
  )
}
